import axios from 'axios';

import type { AnnouncementList } from '../models/announcement';
import { announcementListSchema } from '../models/announcement';

export async function getActiveAnnouncementsForUser(
	signal?: AbortSignal,
): Promise<AnnouncementList> {
	const response = await axios.get<AnnouncementList>('/api/announcements/active', { signal });

	return announcementListSchema.parse(response.data);
}

export async function acknowledgeContent(contentId: number): Promise<void> {
	await axios.post('/api/announcements', { contentId });
}

export async function getAllAnnouncementsForUser(signal?: AbortSignal): Promise<AnnouncementList> {
	const response = await axios.get<AnnouncementList>('/api/announcements/all', { signal });

	return announcementListSchema.parse(response.data);
}
